"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DialogActions: function() {
        return _index.DialogActions;
    },
    dialogActionsClassNames: function() {
        return _index.dialogActionsClassNames;
    },
    renderDialogActions_unstable: function() {
        return _index.renderDialogActions_unstable;
    },
    useDialogActionsStyles_unstable: function() {
        return _index.useDialogActionsStyles_unstable;
    },
    useDialogActions_unstable: function() {
        return _index.useDialogActions_unstable;
    }
});
const _index = require("./components/DialogActions/index");
